exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.half[data-v-4dfa7260] {\n  width: 50%;\n}\n", "", {"version":3,"sources":["/opt/build/repo/src/components/WalletOfCompany/src/components/WalletOfCompany/Index.vue"],"names":[],"mappings":";AAoBA;EACA,WAAA;CACA","file":"Index.vue","sourcesContent":["<script>\nimport History from \"./History\";\nimport Wallet from \"./Wallet\";\n\nexport default {\n  components: {\n    History,\n    Wallet\n  }\n};\n</script>\n\n<template>\n  <div>\n    <Wallet class=\"half\"/>\n    <History/>\n  </div>\n</template>\n\n<style scoped>\n.half {\n  width: 50%;\n}\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4dfa7260","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/WalletOfCompany/Index.vue
// module id = P9s1
// module chunks = 1